export default {
  root: {
    flex: 1,
    flexDirection: 'column',
    padding: 50,
    backgroundColor: 'light-gray',
    height: '100vh',
    alignItems: 'center',
  },
  tableTop: {
    marginBottom: 10,
  },
  busyBackdrop: {
    zIndex: 2000,
  },
  createButton: {},
  title: {},
}
